(function () {
  const BASE_LABELS = ['preço por kg', 'price per kg'];
  const isEnglish = () => document.documentElement.lang.toLowerCase().startsWith('en');
  const isBaseLabel = (value = '') => {
    const label = value.trim().toLowerCase();
    return BASE_LABELS.some((base) => label === base || label.startsWith(base + ' -'));
  };
  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    return 'Kz' + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
  };
  const stockText = (quantity, tracked) => {
    if (!tracked) return isEnglish() ? 'Available' : 'Disponível';
    if (quantity <= 0) return isEnglish() ? 'Out of stock' : 'Esgotado';
    if (quantity === 1) return isEnglish() ? '1 unit available' : '1 unidade disponível';
    return isEnglish() ? quantity + ' units available' : quantity + ' unidades disponíveis';
  };

  function setupProductForm(productForm) {
    if (productForm.dataset.aptStockReady === 'true') return;
    const inventoryScript = productForm.querySelector('script[data-apt-product-inventory]');
    const buttons = productForm.querySelector('.product-form-buttons');
    if (!inventoryScript || !buttons) return;

    let variants;
    try {
      variants = JSON.parse(inventoryScript.textContent || '[]');
    } catch (_) {
      return;
    }
    productForm.dataset.aptStockReady = 'true';

    const panel = document.createElement('div');
    panel.className = 'apt-stock-quantity';
    panel.innerHTML =
      '<div class="apt-stock-quantity__stock" data-status="waiting"><i></i><span></span></div>' +
      '<div class="apt-stock-quantity__row" hidden>' +
        '<label>' + (isEnglish() ? 'Quantity' : 'Quantidade') + '</label>' +
        '<div class="apt-stock-quantity__stepper">' +
          '<button type="button" data-minus aria-label="' + (isEnglish() ? 'Decrease quantity' : 'Diminuir quantidade') + '">−</button>' +
          '<input name="quantity" type="number" min="1" step="1" value="1" inputmode="numeric" aria-label="' + (isEnglish() ? 'Quantity' : 'Quantidade') + '">' +
          '<button type="button" data-plus aria-label="' + (isEnglish() ? 'Increase quantity' : 'Aumentar quantidade') + '">+</button>' +
        '</div>' +
      '</div>';
    const addButton = buttons.querySelector('button[name="add"]');
    const addWrapper = addButton && (addButton.closest('span') || addButton);
    buttons.insertBefore(panel, addWrapper || null);

    const stock = panel.querySelector('.apt-stock-quantity__stock');
    const stockLabel = stock.querySelector('span');
    const row = panel.querySelector('.apt-stock-quantity__row');
    const input = panel.querySelector('input[name="quantity"]');
    const minus = panel.querySelector('[data-minus]');
    const plus = panel.querySelector('[data-plus]');

    const limitQuantity = () => {
      const min = 1;
      const max = Number(input.max || 999999);
      input.value = Math.max(min, Math.min(max, Number(input.value) || min));
      minus.disabled = Number(input.value) <= min;
      plus.disabled = Number(input.value) >= max;
    };
    minus.addEventListener('click', () => { input.value = Number(input.value || 1) - 1; limitQuantity(); });
    plus.addEventListener('click', () => { input.value = Number(input.value || 1) + 1; limitQuantity(); });
    input.addEventListener('input', limitQuantity);
    input.addEventListener('change', limitQuantity);

    const sync = () => {
      const section = productForm.closest('.shopify-section');
      const select = section && section.querySelector('.variant-option__select');
      const option = select && select.options[select.selectedIndex];
      const variantId = (option && option.dataset.variantId) || productForm.querySelector('input[name="id"]')?.value;
      const selectedLabel = option?.textContent || '';
      const variant = variants.find((item) => String(item.id) === String(variantId));
      const waiting = isBaseLabel(selectedLabel);

      if (variant?.price != null && section) {
        section.querySelectorAll('product-price [ref="priceContainer"] .price').forEach((price) => {
          price.textContent = formatMoney(variant.price);
        });
      }

      if (waiting || !variant) {
        stock.dataset.status = 'waiting';
        stockLabel.textContent = isEnglish() ? 'Select a size to see available stock' : 'Selecione um tamanho para consultar o stock';
        row.hidden = true;
        input.disabled = true;
        return;
      }

      const tracked = variant.inventory_management === 'shopify';
      const quantity = tracked ? Math.max(0, Number(variant.inventory_quantity || 0)) : null;
      stock.dataset.status = tracked && quantity <= 0 ? 'out' : 'available';
      stockLabel.textContent = stockText(quantity, tracked);
      row.hidden = tracked && quantity <= 0;
      input.disabled = tracked && quantity <= 0;
      input.value = 1;
      if (tracked) input.max = Math.max(1, quantity);
      else input.removeAttribute('max');
      limitQuantity();
    };

    const select = productForm.closest('.shopify-section')?.querySelector('.variant-option__select');
    select?.addEventListener('change', () => window.setTimeout(sync, 120));
    sync();
  }

  function setup(root = document) {
    root.querySelectorAll?.('#MainContent[data-template^="product"] .product-details product-form-component').forEach(setupProductForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) setup();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
